import { createFileRoute } from '@tanstack/react-router'
import { vacancySearchSchema } from '@/features/vacancies/filter-vacancies/model/vacancySearch'
import { VacanciesPage } from '@/pages/vacancies/ui/VacanciesPage'

export const Route = createFileRoute('/vacancies')({
  validateSearch: vacancySearchSchema,
  component: VacanciesPage,
})
